export default __webpack_public_path__ + "static/media/b0b822ad6cb7792d80be855f41dcc531284ced053b16a1cfb95db445de6466e6.b41cf93a.svg";